import Swiper, { Navigation, Pagination, EffectFade, Controller, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade, Controller, Autoplay]);

document.addEventListener("DOMContentLoaded", () => {

	// BG Swiper //
    const swiperBG = new Swiper('.swiper-bg', {
        spaceBetween: 30,
        effect: 'fade',
        loop: false,
        speed: 500,
        slidesPerView: 1,
        // autoplay: {
        //     delay: 4500,
        //     disableOnInteraction: false,
        // },

    });

    // Content Swiper //
    const swiperContent = new Swiper('.swiper-content', {
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: true,
        loop: false,
        speed: 500,
        grabCursor: true,
        effect: 'fade',

        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        controller: {
            control: [swiperBG],
            by: 'container',
        },

        breakpoints: {
            768: {
                slidesPerView: 1,
            },
        }

    });

    // check to see if the swiper exists //
    const swiperWrap = document.getElementById('swiperWrap');

    if(swiperWrap){
        swiperBG.controller.control = swiperContent;
        swiperContent.controller.control = swiperBG;
    }
});